import axios from 'axios';

export default async function getCompanyGroup({
  accessToken,
  id,
  setTokenLikeExpired,
}) {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_COMPANY_GROUPS_API_URL}/${id}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    return data;
  } catch (err) {
    if (err.response?.status === 401 && setTokenLikeExpired) setTokenLikeExpired();

    return null;
  }
}
